module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/error-modal/error-modal.component.scss
// module id = ./src/app/components/tools/modals/error-modal/error-modal.component.scss
// module chunks = main